import { SizableText, YStack } from 'tamagui';
import { ListItem } from './ListItem';
import type { ListSectionProps } from './list.types';

/**
 * Component for a section within a list.
 * Contains a title and a list of items.
 */
export const ListSection = ({
  title,
  items,
}: ListSectionProps): React.ReactNode => {
  return (
    <YStack gap="$2">
      <SizableText size="$5" fontFamily="$bold">
        {title}
      </SizableText>
      <YStack gap="$2">
        {items.map((item, index) => (
          <ListItem
            key={item.id || index}
            title={item.title}
            subtitle={item.subtitle}
            iconBefore={item.iconBefore}
            iconAfter={item.iconAfter}
            onPress={item.onPress}
          />
        ))}
      </YStack>
    </YStack>
  );
};
